import { draw } from './draw'
import { resize } from './resize'
import { drag } from './drag'

export const mouseUpActions = {
  draw,
  resize,
  drag,
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseUp/index.js